module.exports = __webpack_public_path__ + "media/applicants/help-icon@2x-8ad31ed9.png";